import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CryptoService {
  private static readonly S_KEY = 'skylarkControl';

  encryptText(message: any) {
    const ciphertext = CryptoJS.AES.encrypt(message, CryptoService.S_KEY);
    return ciphertext.toString();
  }

  decryptText(ciphertext: any) {
    const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), CryptoService.S_KEY);
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  encryptObject(data: any) {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoService.S_KEY);
    return ciphertext.toString();
  }

  decryptObject(ciphertext: any) {
    const bytes = CryptoJS.AES.decrypt(ciphertext.toString(), CryptoService.S_KEY);
    const plaintext = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return plaintext;
  }
}
